/*
 * Author M. Atoar Rahman
 * Title: D3Report
 * Description: Page for D3Report
 * Date: 15/03/2022
 */

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { D3ReportProvider } from '../unhcr/d3Reports/ContextAPI';
import Index from '../unhcr/d3Reports/Index';
import PermissionDenied from './PermissionDenied';

export default function D3Report() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['d3-reports']) return <PermissionDenied />;

    return (
        <D3ReportProvider>
            <Index />
        </D3ReportProvider>
    );
}
